import React, { useContext } from 'react'
import styled, { css, ThemeContext } from 'styled-components'

// Styles
import { hsla } from '../styles/colors'
import { mqFrom } from '../styles/mediaQueries'

// Components
import Avatar, { AvatarSize } from './Avatar'
import { Icon } from './icon'
import ExternIcon from './icon/ExternIcon'

// Types
import { ICompanyMember } from '../common/models/Company'

interface IProps {
  className?: string
  assessor?: ICompanyMember
  external?: boolean
  isAssessmentSubmitted: boolean
}

const AssessorAvatar: React.FC<IProps> = ({
  className,
  assessor,
  external,
  isAssessmentSubmitted,
}) => {
  const themeContext = useContext(ThemeContext)
  return (
    <AssessorAvatarWrapper
      className={className}
      isAssessmentSubmitted={isAssessmentSubmitted}
    >
      {assessor && <Avatar user={assessor} size={AvatarSize.ExtraSmall} />}
      {external && (
        <StyledExternIcon
          size={18}
          color={themeContext.colors.textLight}
          backgroundSize={24}
          backgroundColor="primaryLight"
        />
      )}
      <StyledCheckIcon
        type="Check"
        color={themeContext.colors.lightest}
        size={16}
      />
    </AssessorAvatarWrapper>
  )
}

const StyledCheckIcon = styled(Icon)``

const StyledExternIcon = styled(ExternIcon)`
  ${mqFrom.M`
    width: 28px;
    height: 28px;
  `}

  ${mqFrom.L`
    width: 36px;
    height: 36px;
  `}
`

const AssessorAvatarWrapper = styled.div<{
  isAssessmentSubmitted: boolean
}>`
  flex-shrink: 0;
  margin-right: 6px;

  > ${StyledCheckIcon} {
    display: none;
  }

  ${mqFrom.L`
      margin-right: 12px;

      &:last-child {
        margin-right: 24px;
      }
    `}

  ${({ isAssessmentSubmitted, theme }) =>
    isAssessmentSubmitted &&
    css`
      position: relative;

      &::before {
        content: '';
        z-index: 1;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: block;
        border-radius: 50%;
        background-color: ${hsla(theme.colors.primaryDark, 0.75)};
      }

      > ${StyledCheckIcon} {
        z-index: 1;
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        transform: translate(-50%, -50%);
      }
    `}
`

export default AssessorAvatar
